<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Especialidad</h4>
    <hr />

    <DataTable
      :data="especialidads"
      :columns="columnas"
      idField="idEspecialidad"
      mensajeVacio="No hay especialidades registradas."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="esAdmin"
      :mostrarEliminar="false"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idEspecialidad)"
      @view="row => abrirEditar(row.idEspecialidad)"
    >
      <!-- Búsqueda por nombre en la barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Celda personalizada: clasificación legible -->
      <template #cell-clasificacion="{ row }">
        <span class="badge" :class="badgeClasificacion(row.clasificacion)">
          {{ labelClasificacion(row.clasificacion) }}
        </span>
      </template>

      <!-- Acciones extra por fila: acceso rápido a detalles -->
      <template #acciones-fila="{ row }">
        <button
          v-if="esAdmin"
          class="btn btn-sm btn-outline-secondary"
          @click="abrirEditar(row.idEspecialidad)"
          title="Ver prestadores de esta especialidad"
        >
          <span class="material-icons" style="font-size:14px">groups</span>
        </button>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEspecialidad.idEspecialidad"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEspecialidad.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Tipo -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Tipo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoEspecialidad.tipo" required>
                      <option disabled value="">Seleccione...</option>
                      <option value="MÉDICO-QUIRÚRGICAS">MÉDICO-QUIRÚRGICAS</option>
                      <option value="PREVENCIÓN, PROMOCIÓN Y SALUD PÚBLICA">PREVENCIÓN, PROMOCIÓN Y SALUD PÚBLICA</option>
                      <option value="QUIRÚRGICAS">QUIRÚRGICAS</option>
                      <option value="CLÍNICAS">CLÍNICAS</option>
                      <option value="LABORATORIO O DIAGNÓSTICAS">LABORATORIO O DIAGNÓSTICAS</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Clasificación -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Clasificación</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoEspecialidad.clasificacion" required>
                      <option disabled value="">Seleccione...</option>
                      <option value="M">Medicina</option>
                      <option value="P">Psicología</option>
                      <option value="R">Rehabilitación</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Título -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Título</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoEspecialidad.titulo" required>
                      <option disabled value="">Seleccione un título</option>
                      <option
                        v-for="t in titulos"
                        :key="t"
                        :value="t"
                      >{{ t }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Estado -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Estado</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoEspecialidad.estado" required>
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarEspecialidad"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarEspecialidad"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import { titulos }     from "@/data/titulos.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "EspecialidadList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      especialidads:    [],
      datoEspecialidad: {},
      nombreBusqueda:   "",
      titulo:           "",
      btnCrear:         false,
      btnEditar:        false,
      modalWindow:      true,
      titulos,
      idPerfil:         0,
    };
  },

  computed: {
    esAdmin() {
      return Number(this.idPerfil) === 1;
    },

    columnas() {
      return [
        { label: "Nombre",        field: "nombre" },
        { label: "Tipo",          field: "tipo" },
        // clasificacion usa slot personalizado #cell-clasificacion
        { label: "Clasificación", field: "clasificacion" },
      ];
    },
  },

  mounted() {
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwespecialidads")
        .then(r => { this.especialidads = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar especialidades:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwespecialidads/nombre/" + nombre)
        .then(r => { this.especialidads = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar por nombre:", e));
    },

    // ── Utilidades de clasificación ───────────────────────────
    labelClasificacion(c) {
      const map = { M: "Medicina", P: "Psicología", R: "Rehabilitación" };
      return map[c] ?? "Desconocida";
    },

    badgeClasificacion(c) {
      return {
        "bg-primary":   c === "M",
        "bg-success":   c === "P",
        "bg-warning text-dark": c === "R",
        "bg-secondary": !["M", "P", "R"].includes(c),
      };
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoEspecialidad,
        ["nombre", "tipo", "clasificacion"],
        ["Nombre", "Tipo", "Clasificación"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarEspecialidad() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/especialidads", this.datoEspecialidad);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Especialidad creada exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarEspecialidad() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/especialidads", this.datoEspecialidad);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Especialidad actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteEspecialidad(idEspecialidad) {
      const confirm = await Swal.fire({
        title: "¿Eliminar especialidad?",
        text:  "Esta acción no se puede deshacer.",
        icon:  "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/especialidads/" + idEspecialidad);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow      = true;
      this.datoEspecialidad = {};
      this.titulo           = "Crear Especialidad";
      this.btnCrear         = true;
      this.btnEditar        = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idEspecialidad) {
      this.modalWindow = true;
      this.titulo      = "Editar Especialidad";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp            = await api.get("/vwespecialidads/" + idEspecialidad);
        this.datoEspecialidad = resp.data;
      } catch (e) {
        console.error("Error al cargar especialidad:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idEspecialidad) {
      if (idEspecialidad != null) {
        this.$router.push("/especialidad_espepres/" + idEspecialidad);
      }
    },
  },
};
</script>